import React, { useState, useEffect } from "react";
import { Modal, Button, Form, Row, Col } from "react-bootstrap";

const EMPTY_FORM = {
  name: "",
  type: "",
  amount: "",
  description: "",
  function: "",
};

const CreateEditModal = ({ show, onHide, onSubmit, impress }) => {
  const isEdit = !!impress;
  const [form, setForm] = useState(EMPTY_FORM);
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (impress) {
      setForm({
        name: impress.name || "",
        type: impress.type || "",
        amount: impress.amount || "",
        description: impress.description || "",
        function: impress.function || "",
      });
    } else {
      setForm(EMPTY_FORM);
    }
  }, [impress, show]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const isFormValid = () =>
    form.name.trim() &&
    form.type.trim() &&
    form.amount &&
    form.description.trim() &&
    form.function.trim();

  // const handleSubmit = async () => {
  //   if (!isFormValid()) return;
  //   setSubmitting(true);
  //   await onSubmit(form);
  //   setSubmitting(false);
  // };

  const handleSubmit = async () => {
    if (!isFormValid()) return;
    setSubmitting(true);
    try {
      await onSubmit(form);
    } catch (error) {
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title style={{ fontSize: 16 }}>
          {isEdit ? "Edit Imprest" : "New Imprest"}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Form>
          <Form.Group style={{ marginBottom: 14 }}>
            <Form.Label style={{ fontSize: 13, color: "#6b7280" }}>
              Name
            </Form.Label>
            <Form.Control
              type="text"
              name="name"
              value={form.name}
              onChange={handleChange}
              placeholder="e.g. Generator Purchase"
              size="sm"
            />
          </Form.Group>

          <Row>
            <Col xs={6}>
              <Form.Group style={{ marginBottom: 14 }}>
                <Form.Label style={{ fontSize: 13, color: "#6b7280" }}>
                  Type
                </Form.Label>
                <Form.Control
                  type="text"
                  name="type"
                  value={form.type}
                  onChange={handleChange}
                  placeholder="e.g. Equipment, Maintenance"
                  size="sm"
                />
              </Form.Group>
            </Col>
            <Col xs={6}>
              <Form.Group style={{ marginBottom: 14 }}>
                <Form.Label style={{ fontSize: 13, color: "#6b7280" }}>
                  Amount (₦)
                </Form.Label>
                <Form.Control
                  type="number"
                  name="amount"
                  value={form.amount}
                  onChange={handleChange}
                  placeholder="e.g. 50000"
                  size="sm"
                />
              </Form.Group>
            </Col>
          </Row>

          <Form.Group style={{ marginBottom: 14 }}>
            <Form.Label style={{ fontSize: 13, color: "#6b7280" }}>
              Function
            </Form.Label>
            <Form.Control
              type="text"
              name="function"
              value={form.function}
              onChange={handleChange}
              placeholder="e.g. Branch Operations"
              size="sm"
            />
          </Form.Group>

          <Form.Group>
            <Form.Label style={{ fontSize: 13, color: "#6b7280" }}>
              Description
            </Form.Label>
            <Form.Control
              as="textarea"
              name="description"
              value={form.description}
              onChange={handleChange}
              placeholder="Describe what this imprest is for..."
              rows={3}
              size="sm"
            />
          </Form.Group>
        </Form>
      </Modal.Body>

      <Modal.Footer>
        <Button
          variant="light"
          onClick={onHide}
          size="sm"
          disabled={submitting}
        >
          Cancel
        </Button>
        <Button
          variant="dark"
          onClick={handleSubmit}
          size="sm"
          disabled={!isFormValid() || submitting}
        >
          {submitting ? "Saving..." : isEdit ? "Save Changes" : "Submit"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default CreateEditModal;
